export function getDisplayMode() {
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  if (document.referrer.startsWith("android-app://")) {
    return "twa"; // Running as a Trusted Web Activity (TWA)
    //@ts-expect-error our types are not aware of this property
  } else if (navigator.standalone || isStandalone) {
    return "standalone"; // Running as a standalone PWA
  }
  return "browser"; // Running in a regular browser tab
}
